import angular from 'angular';
import lmiTable from './lmiTable';
import lmiTableCtrl from './lmiTableCtrl';

export default angular
  .module('components.lmiTable', [])
  .controller('LmiTableCtrl', lmiTableCtrl)
  .component('lmiTable', lmiTable).name;
